// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/resources/styles/ManageCustomAwards.css
// module id = 8646
// module chunks = 0